


































































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';

import {IpTools} from '@/utils/IpTools';

import {
  ConnectionState,
  ConnectionStateColor,
  ConnectionStateLabel,
} from '@/model/network/connection/ConnectionState';

import NetworkProfilesStore from '@/store/network/NetworkProfiles.store';
import NetworkConnectionsStore from '@/store/network/NetworkConnections.store';

import {BaseComponent} from '@/mixins/BaseComponent';
import PropertyDisplayer from '@/components/Utils/PropertyDisplayer.vue';

@Component({
  components: {PropertyDisplayer},
})
export default class NetworkVpnStatus extends Mixins<BaseComponent>(BaseComponent) {

  private IpTools = IpTools;
  private ConnectionState = ConnectionState;
  private ConnectionStateColor = ConnectionStateColor;
  private ConnectionStateLabel = ConnectionStateLabel;

  private profilesStore: NetworkProfilesStore = getModule(NetworkProfilesStore, this.$store);

  private connectionsStore: NetworkConnectionsStore = getModule(NetworkConnectionsStore, this.$store);

  private async mounted() {
    try {
      await this.profilesStore.fetchProfiles(true);
    } catch (error) {

    }

    try {
      await this.connectionsStore.fetchConnections(true);
    } catch (error) {

    }
  }
}
